import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuiaToldoNoRecoge from "../pages/guias/toldo-no-recoge/page";
import GuiaBrazoToldoRoto from "../pages/guias/brazo-toldo-roto/page";
import GuiaCambiarLonaToldo from "../pages/guias/cambiar-lona-toldo/page";
import GuiaToldoDescolgado from "../pages/guias/toldo-descolgado/page";
import GuiaCambiarMotorToldo from "../pages/guias/cambiar-motor-toldo/page";
import GuiasIndex from "../pages/guias/index/page";
import ReparacionToldosMalaga from "../pages/servicios/reparacion/page";
import InstalacionToldosMalaga from "../pages/servicios/instalacion/page";
import MotorizacionToldosMalaga from "../pages/servicios/motorizacion/page";
import MantenimientoToldosMalaga from "../pages/servicios/mantenimiento/page";
import Hosteleria from "../pages/toldos-hosteleria/page";
import Presupuesto from "../pages/presupuesto/page";
import Contacto from "../pages/contacto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/reparacion-toldos-malaga",
    element: <ReparacionToldosMalaga />,
  },
  {
    path: "/instalacion-toldos-malaga",
    element: <InstalacionToldosMalaga />,
  },
  {
    path: "/motorizacion-toldos-malaga",
    element: <MotorizacionToldosMalaga />,
  },
  {
    path: "/mantenimiento-toldos-malaga",
    element: <MantenimientoToldosMalaga />,
  },
  {
    path: "/toldos-hosteleria",
    element: <Hosteleria />,
  },
  {
    path: "/guias",
    element: <GuiasIndex />,
  },
  {
    path: "/guias/toldo-no-recoge",
    element: <GuiaToldoNoRecoge />,
  },
  {
    path: "/guias/brazo-toldo-roto",
    element: <GuiaBrazoToldoRoto />,
  },
  {
    path: "/guias/cambiar-lona-toldo",
    element: <GuiaCambiarLonaToldo />,
  },
  {
    path: "/guias/toldo-descolgado",
    element: <GuiaToldoDescolgado />,
  },
  {
    path: "/guias/cambiar-motor-toldo",
    element: <GuiaCambiarMotorToldo />,
  },
  {
    path: "/presupuesto",
    element: <Presupuesto />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;